/**
 * idp-service base URL (Portal FE migration).
 */
export function getIdpApiBase() {
    const config = window.__RUNTIME_CONFIG__ || {};
    if (config.REACT_APP_IDP_API_URL) {
        const url = config.REACT_APP_IDP_API_URL;
        return url.endsWith('/') ? url : `${url}/`;
    }
    const root = window.ApiURL || '';
    return root.endsWith('/') ? `${root}idp/` : `${root}/idp/`;
}
